import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSidenav } from "@angular/material/sidenav";
import { AuthService } from "../services/auth.service";
import { Cluster } from '../models/cluster.model';
import { Subscription } from 'rxjs';
import { ClustersService } from '../services/clusters.service';
import { ConfigService } from '../services/config.service';
import { User } from '../models/user.model';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss']
})
export class ToolsComponent implements OnInit, OnDestroy {

  selectedTab: string;
  alertCode: string = '';

  user: User;
  userSubscription: Subscription;
  currentCluster: Cluster;
  currentClusterSubscription: Subscription;
  clusterList: Cluster[];
  clusterListSubscription: Subscription;

  isDarkThemeSubscription: Subscription;
  isDarkTheme: boolean;

  @ViewChild('drawer', { static: false })
  drawer: MatSidenav;

  fileIsUploading = false; // picture update status
  fileUploaded = false; // picture update status

  constructor(private route: ActivatedRoute,
              private router: Router,
              private authService: AuthService,
              private userService: UserService,
              private clustersService: ClustersService,
              private configService: ConfigService) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        if (this.route.snapshot.params['tab']) {
          this.selectedTab = params['tab'];
        }
      }
    );

    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        this.user = user;
      }
    );
    this.authService.emitUser();

    this.clusterListSubscription = this.clustersService.clusterListSubject.subscribe(
      (clusterList: Cluster[]) => {
        this.clusterList = clusterList;
        if (this.selectedTab==undefined) {
          if (clusterList.length==0) {
            this.selectedTab = 'my-portfolio';
          } else {
            this.selectedTab = 'dashboard';
          }
        }
      }
    );
    this.clustersService.emitClusterList();

    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (currentCluster: Cluster) => {
        this.currentCluster = currentCluster;
      }
    );
    this.clustersService.emitCurrentCluster();

    this.isDarkThemeSubscription = this.configService.isDarkThemeSubject.subscribe(
      (isDarkTheme: boolean) => {
        this.isDarkTheme = isDarkTheme;
      }
    );
    this.configService.emitIsDarkTheme();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.currentClusterSubscription.unsubscribe();
    this.clusterListSubscription.unsubscribe();
    this.isDarkThemeSubscription.unsubscribe();
  }

  async onSignOut() {
    const data:any = await this.authService.signOutUser();
    this.alertCode = 'auth/sign-out-ok';
    this.router.navigate(['/']);
  }

  onThemeChange() {
    this.configService.onSwitchTheme();
  }

  async detectFiles(event) {
    let file: File = event.target.files[0];

    // start picture update
    this.fileIsUploading = true;
    await this.userService.updatePicture(file);

    // picture update complete
    this.fileIsUploading = false;
    this.fileUploaded = true;
  }
}
